import axios from "axios";
import React, {useEffect, useState, useRef, Fragment} from "react";
import {Link, NavLink, useParams, useNavigate, useLocation} from "react-router-dom"
import {render} from "react-dom";
import clientconfigwebapp, {
    empty_bk, convert_to_english_strhk, scrollTo_uphk, check_login_appbk, Token_get_appbk, redirectbh_typeb,
} from '../../../clientconfigwebapp';
import {ToastContainer, toast} from 'react-toastify';

import Master_Front_Buyer from "../../Master_Front_Buyer";


import "../../../components/assets/css/profile.css"
import "../../../assets/cssnew/panel.css"

import ReactFullPageLoadinghk from "../../../components/layaout/LoadingFullpagehk";


import Tab1_view from "../../../components/Panel_Simple/Profile_edit/Tab1_view";


import Grid from '@mui/material/Grid';


import {Back, Iconbk_edit1, Information} from '../../../assets/icones/icones';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';


const serialize = require('form-serialize');


const Profile_Edit = () => {
    const location = useLocation()
    const {tab_show_by_url} = useParams();


    const location_get_urlbk = useLocation();
    const redirect_navigate = useNavigate();
    const [loadinghkfullshow, Setloadinghkfullshow] = useState("false");

    /*  start profile */
    const [wallet_balance, setData_wallet_balance] = useState('0');
    const [first_name_profile, setData_first_name_profile] = useState('');
    const [last_name_profile, setData_last_name_profile] = useState('');
    const [profile_src, setData_profile_src] = useState('');
    const [type_user_panel, setData_type_user_panel] = useState('');
    /*  end profile */
    const [active_tab_curent, set_active_tab_curent] = useState("tab1")

    const [Data_Full_Get, set_Data_Full_Get] = useState([]);


    /*  start code file_upload  */
    const [file, setFile] = React.useState();
    const [file_name_get, set_file_name] = React.useState('');
    const uploadRef = React.useRef();
    const statusRef = React.useRef();
    const loadTotalRef = React.useRef();
    const progressRef = React.useRef();
    const [attach_file_get, set_attach_file] = useState('');
    const [show_hide_pogressbar, setshow_hide_pogressbar] = useState('none');
    const [uploadUrl, setUploadUrl] = useState('')
    /*  endddd code file_upload  */



    //provinces and city start
    const [provinces, setProvinces] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedProvince, setSelectedProvince] = useState('');
    const [filteredCities, setFilteredCities] = useState([]);
    //provinces and city end

    useEffect(() => {
        scrollTo_uphk();
        if (check_login_appbk() == false) {
            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login");
            return false;
        }


        Load_api_page();

    }, [location_get_urlbk]);

    const Load_api_page = () => {
        scrollTo_uphk();
        if (check_login_appbk() == false) {
            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login");
        }

        const config = {
            headers: {Authorization: `Bearer ${Token_get_appbk()}`}
        };

        Setloadinghkfullshow("true");

        const params = new URLSearchParams();
        params.append('page', "edit_profile");


        axios.post(`${clientconfigwebapp.siteurl}api/v1/dashboard-get`, params, config)
            .then((res) => {
                Setloadinghkfullshow("false");
                console.log(res.data);
                if (String(res.data).length > 0) {

                    if (String(res.data.data) == "login-show") {
                        redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login");
                    }

                    if (!empty_bk(res.data.type_user)) {
                        setData_type_user_panel(res.data.type_user);
                    }
                       if (String(res.data).length > 0) {    set_Data_Full_Get(res.data);  }


                    if (String(res.data.wallet_inventory).length > 0) {
                        setData_wallet_balance(res.data.wallet_inventory);
                    }

                    if (!empty_bk(res.data.first_name_profile)) {
                        setData_first_name_profile(res.data.first_name_profile);
                        localStorage.setItem('first_name_Get', res.data.first_name_profile);
                    }
                    if (!empty_bk(res.data.last_name_profile)) {
                        setData_last_name_profile(res.data.last_name_profile);
                        localStorage.setItem('last_name_Get', res.data.last_name_profile);
                    }


                    if (!empty_bk(res.data.profile_src)) {
                        setData_profile_src(res.data.profile_src);
                        setUploadUrl(res.data.profile_src);
                    }

                      setProvinces(res.data.list_provinces);
                       setCities(res.data.list_cities);

                    // if (!empty_bk(res.data.list_provinces)) {   setProvinces(res.data.list_provinces);  }
                    // if (!empty_bk(res.data.list_cities)) {   setCities(res.data.list_cities);  }


                    console.log(res.data.list_provinces,"ppppppprrrrrrrrr");


                } else {
                    if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }

            }).catch((err) => {
            Setloadinghkfullshow("false");
            toast.error('خطا اتصال به سرور کد  435346', {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        });


    }


    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setUploadUrl(URL.createObjectURL(file));
        document.querySelector(`#${e.target.ariaLabel}`).classList.toggle('image_up_act');

        UploadFile_start();
    }
    const deleteUploadBg = (e) => {
        if (uploadUrl !== '') {
            setUploadUrl('');
            document.querySelector(`#${e.target.ariaLabel}`).classList.toggle('image_up_act');
        }

        set_attach_file('');
    }


    const UploadFile_start = () => {
        const file = uploadRef.current.files[0];
        console.log(file, "filefilefile");
        ///// setFile(URL.createObjectURL(file));
        setFile(URL.createObjectURL(file));
        set_file_name(file.name);
        var formData = new FormData();
        formData.append("fileattach", file);
        var xhr = new XMLHttpRequest();
        xhr.upload.addEventListener("progress", ProgressHandler, false);
        xhr.addEventListener("load", SuccessHandler, false);
        xhr.addEventListener("error", ErrorHandler, false);
        xhr.addEventListener("abort", AbortHandler, false);
        xhr.open("POST", String(clientconfigwebapp.host_dl_get) + "upload.php");
        xhr.send(formData);


    };

    const ProgressHandler = (e) => {
        set_attach_file("");
        setshow_hide_pogressbar("flex");
        /// loadTotalRef.current.innerHTML = `uploaded ${e.loaded} bytes of ${e.total}`;
        var percent = (e.loaded / e.total) * 100;
        progressRef.current.value = Math.round(percent);
        ///statusRef.current.innerHTML = Math.round(percent) + "% uploaded...";
        statusRef.current.innerHTML = Math.round(percent) + "%";
    };

    const SuccessHandler = (e) => {
        set_attach_file("");
        var respons_get = e.target.response;

        ///  statusRef.current.innerHTML = e.target.responseText;
        progressRef.current.value = 0;
        statusRef.current.innerHTML = "0%";

        ///  setshow_hide_pogressbar("flex");

        console.log(respons_get, "respons_get");


        if (String(respons_get).length > 0) {

            var respons_get_json = JSON.parse(respons_get);


            if (String(respons_get_json.data).length > 0) {


                if (String(respons_get_json.data) == "success" && !empty_bk(String(respons_get_json.file_name_get))) {


                    set_attach_file(String(respons_get_json.file_name_get));
                    progressRef.current.value = 100;
                    statusRef.current.innerHTML = "Profile Picture Uploaded";

                    if (String(respons_get_json.msgwebapp).length > 0) {
                        toast.success(respons_get_json.msgwebapp, {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }


                } else {


                    if (String(respons_get_json.msgwebapp).length > 0) {
                        toast.error(respons_get_json.msgwebapp, {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }

                }


            } else {

                if (String(respons_get_json.msgwebapp).length > 0) {
                    toast.error(respons_get_json.msgwebapp, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }

            }


        } else {

            toast.error("خطا در آپلود فایل کد خطا 654754", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

        }


    };


    const ErrorHandler = () => {
        statusRef.current.innerHTML = "upload failed!!";
        setshow_hide_pogressbar("none");
        set_attach_file("");
        toast.error("خطا در ارتباط با سرور، اینترنت خود را بررسی کنید. کد خطا 345346", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    const AbortHandler = () => {
        statusRef.current.innerHTML = "upload aborted!!";
        setshow_hide_pogressbar("none");
        set_attach_file("");
        toast.error("خطا در ارتباط با سرور، اینترنت خود را بررسی کنید. کد خطا 567567", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };


    return (<Fragment>

            <Master_Front_Buyer type_user_panel={type_user_panel} wallet_balance={wallet_balance}
                                first_name_profile={first_name_profile} last_name_profile={last_name_profile}
                                profile_src={profile_src}>
                <ReactFullPageLoadinghk loadinghk={loadinghkfullshow}/>
                <ToastContainer/>

                <div className={"box-content-panelbk"}>

                    <span className={"title-box-content-panel"}>حساب کاربری</span>

                    <div className={"container-bk"}>

                        <form id={"form_data_profile"} name={"form_data_profile"} encType="multipart/form-data"
                              style={{width: "100%"}}>


                            <div style={{
                                width: "100%",
                                "flexDirection": "column",
                                display: String(active_tab_curent) === 'tab1' ? 'flex' : 'none'
                            }}>

                                <Grid container direction="row" spacing={2} style={{paddingTop: "14px"}}>


                                    <Grid item lg={4} md={4} sm={12} xs={12}>


                                        <div className={"edit_profile_box_right"}>

                                            <input type={"text"} value={attach_file_get} name="attach_file_get"
                                                   style={{display: "none"}}/>
                                            <div className='flexColStartStart upload_image_wrapper'>

                                                <input
                                                    accept="image/*"
                                                    style={{display: 'none'}}
                                                    id="image-upload"
                                                    aria-label='up_1'
                                                    type="file"
                                                    name={"fileget"}
                                                    ref={uploadRef} onChange={handleImageChange}

                                                />

                                                <div className='flexRowStartEnd'>
                                                    <label className='upload_image' id='up_1'
                                                           style={{backgroundImage: `url(${uploadUrl})`}}
                                                           htmlFor="image-upload"><span><Iconbk_edit1/> </span></label>
                                                </div>


                                                <div style={{display: show_hide_pogressbar}}>
                                                    <progress ref={progressRef} value="0" max="100"
                                                              style={{display: "none"}}/>
                                                    <span className={"pers"} ref={statusRef} style={{
                                                        "marginTop": "12px",
                                                        "lineHeight": "1.6",
                                                        "color": "#009688",
                                                        "fontWeight": "normal",
                                                        "fontSize": "17px",
                                                        "fontFamily": "'iran'",
                                                        "display": "block",
                                                        "width": "100%"
                                                    }}></span>
                                                </div>



                                            </div>


                                            <span className={"edit_profile_box_name"}>{String(first_name_profile) + " " + String(last_name_profile)}</span>

                                            <span style={{"display":"block","textAlign":"center","paddingBottom":"21px","fontSize":"13px","color":"#918684"}}>خراسان رضوی مشهد</span>

                                        </div>

                                    </Grid>


                                    <Grid item lg={8} md={8} sm={12} xs={12}>

                                        <Tab1_view setActiveTabCurrent={set_active_tab_curent}
                                                   Data_Full_Get={Data_Full_Get} provinces={provinces} cities={cities}/>



                                    </Grid>

                                </Grid>


                            </div>


                            <div style={{
                                width: "100%",
                                "flexDirection": "column",
                                "paddingTop": "28px",
                                "paddingBottom": "25px",
                                display: String(active_tab_curent) === 'tab2' ? 'flex' : 'none'
                            }}>


                                <div style={{
                                    "width": "100%",
                                    "flexDirection": "column",
                                    "paddingTop": "28px",
                                    "paddingBottom": "13px",
                                    "display": "flex",
                                    "justifyContent": "center",
                                    "alignItems": "center"
                                }}>
                                    <svg width={63} height={63} viewBox="0 0 63 63" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_0_4438)">
                                            <path
                                                d="M31.5 5.66669C17.24 5.66669 5.66663 17.24 5.66663 31.5C5.66663 45.76 17.24 57.3334 31.5 57.3334C45.76 57.3334 57.3333 45.76 57.3333 31.5C57.3333 17.24 45.76 5.66669 31.5 5.66669ZM26.3333 44.4167L13.4166 31.5L17.0591 27.8575L26.3333 37.1059L45.9408 17.4984L49.5833 21.1667L26.3333 44.4167Z"
                                                fill="#0E9F6E"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_0_4438">
                                                <rect width={62} height={62} fill="white"
                                                      transform="translate(0.5 0.5)"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <span style={{
                                        fontSize: '22px',
                                        fontWeight: 'bold',
                                        marginBottom: '30px',
                                        marginTop: '30px'
                                    }}>موفق</span>
                                    <span style={{
                                        fontSize: '15px',
                                        color: '#4B5563',
                                        fontFamily: '"iran"',
                                        display: 'block',
                                        textAlign: 'center',
                                        "lineHeight": "1.6"
                                    }}>
                                       پروفایل کاربری شما، با موفقیت ذخیره شد.
                                    </span>


                                </div>


                            </div>


                        </form>

                    </div>

                </div>


            </Master_Front_Buyer>
        </Fragment>
    );
}


export default Profile_Edit;